import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFolder, faDownload, faTimes } from '@fortawesome/free-solid-svg-icons'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from "moment";
import { remove } from '../../actions/file'
import { getDisplayedName } from '../../dataProvider/file'
import useWindowDimensions from "../util/Window"
import "../../scss/v2/user/cloud.scss"

function CloudFile(props) {

    const { t } = useTranslation();
    const { width } = useWindowDimensions();
    const [deleted, setDeleted] = useState(false);

    const getFileType = (fileToProcess) => {
        return fileToProcess.name.split('.')[fileToProcess.name.split('.').length - 1].toUpperCase()
    }

    function handleFileDelete(fileUrl) {
        if (!window.confirm(t('cloud.delete.confirm'))) return;
        setDeleted(true);
        props.dispatch(remove(fileUrl))
            .catch(err => console.error(err))
    }

    if (deleted) return null;

    if (width < 900) {
        return (
            <>
                <tr className={`cloud-file-row${props.index % 2 === 1 ? ' green-row' : ''}`} key={props.index + '-a'}>
                    <td className="cloud-file-data pb-0">
                        <FontAwesomeIcon icon={faFolder} />
                        <OverlayTrigger placement="right"
                            overlay={<Tooltip id={`tooltip-right-${props.index}`}>{props.file.name}</Tooltip>}
                        >
                            <span className="cloud-file-name">{getDisplayedName(props.file.name)}</span>
                        </OverlayTrigger>
                    </td>
                    <td className="text-right pb-0">
                        <a className="button cloud-file-button mr-3" href={props.file.url} target="_blank" rel="noreferrer">
                            <FontAwesomeIcon icon={faDownload} />
                        </a>
                        <button className="button cloud-file-button" onClick={() => handleFileDelete(props.file.url)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </td>
                </tr>
                <tr className={`cloud-file-row${props.index % 2 === 1 ? ' green-row' : ''}`} key={props.index + '-b'}>
                    <td className="pt-0">
                        <span className="cloud-file-time">{props.file.time}</span>
                        {" | "}
                        {
                            props.file.compressed ?
                                (<span className="cloud-file-convert-mode">{`${getFileType(props.file)} - ${t("cloud.fileType.compressed")}`}</span>) :
                                (<span className="cloud-file-convert-mode">{getFileType(props.file)}</span>)
                        }
                    </td>
                    <td>
                        {props.file.status === 'pending' && (
                            <div className='d-flex justify-content-center' ><div className='spinner-border spinner-border-sm' /></div>
                        )}
                    </td>
                </tr>
            </>
        )
    }
    return (
        <tr className={`cloud-file-row${props.index % 2 === 1 ? ' green-row' : ''}`} key={props.index}>
            <td className="cloud-file-data">
                <FontAwesomeIcon icon={faFolder} />
                <OverlayTrigger placement="right"
                    overlay={<Tooltip id={`tooltip-right-${props.index}`}>{props.file.name}</Tooltip>}
                >
                    <span className="cloud-file-name">{getDisplayedName(props.file.name)}</span>
                </OverlayTrigger>
            </td>
            <td className="cloud-file-time">
                {moment(props.file.date).format('YYYY/MM/DD HH:mm')}
            </td>
            <td className="cloud-file-convert-mode">
                {props.file.compressed ?
                    (<span>{`${getFileType(props.file)} - ${t("cloud.fileType.compressed")}`}</span>) :
                    (<span>{getFileType(props.file)}</span>)
                }

            </td>
            <td className='cloud-file-status' >
                {props.file.status === 'pending' && (
                    <>
                        <span className='spinner-border spinner-border-sm mr-2' />
                        <span className='alert alert-warning' >{t('cloud.file.status.pending')}</span>
                    </>
                )}
                {props.file.status === 'error' && (
                    <span className='alert alert-danger' >{t('cloud.file.status.error')}</span>
                )}
                {props.file.status === 'finished' && (
                    <span className='alert alert-success' >{t('cloud.file.status.finished')}</span>
                )}
            </td>
            <td className="text-right">
                {props.file.status === 'finished' && (
                    <>
                        <a className="button cloud-file-button mr-3" href={props.file.url} target="_blank" rel="noreferrer">
                            <FontAwesomeIcon icon={faDownload} />
                        </a>
                        <button className="button cloud-file-button" onClick={() => handleFileDelete(props.file.url)}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </>
                )}
            </td>
        </tr>
    )

}

const mapStateToProps = state => ({ user: state.user.user })

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(CloudFile)